import { createSupplierSeeds } from './suppliers.js';

const supplierRef = createSupplierSeeds();

const purchasesSeed = [
  {
    id: 'comp-1',
    supplierId: 'prov-1',
    tipo: 'Factura A',
    puntoVenta: '0001',
    numero: '00001234',
    fecha: '2024-09-02',
    cae: '67239012345678',
    caeVto: '2024-09-12',
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: 450000,
      iva21: 94500,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 12000,
      percepIibb: 8000,
      otros: 2500,
      total: 566500,
    },
    items: [
      {
        id: 'comp-1-item-1',
        codigo: 'SERV-REF',
        descripcion: 'Servicio de transporte refrigerado',
        cantidad: 1,
        precio: 450000,
        alicuotaIva: 21,
        subtotal: 450000,
      },
    ],
    adjuntos: [
      {
        id: 'file-1',
        filename: 'FA0001-00001234.pdf',
        url: '/uploads/FA0001-00001234.pdf',
        mimeType: 'application/pdf',
        size: 234000,
      },
    ],
    observaciones: 'Factura mensual logística refrigerada.',
    estado: 'Registrada',
    createdAt: '2024-09-02T15:40:00.000Z',
    updatedAt: '2024-09-02T15:40:00.000Z',
  },
  {
    id: 'comp-2',
    supplierId: 'prov-2',
    tipo: 'Factura B',
    puntoVenta: '0004',
    numero: '00004561',
    fecha: '2024-08-21',
    cae: '47219099887766',
    caeVto: '2024-08-31',
    moneda: 'ARS',
    condicionCompra: 'Contado',
    importes: {
      neto: 88000,
      iva21: 18480,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: 106480,
    },
    items: [
      {
        id: 'comp-2-item-1',
        codigo: 'SERV-MANT',
        descripcion: 'Servicio de mantenimiento mensual',
        cantidad: 1,
        precio: 88000,
        alicuotaIva: 21,
        subtotal: 88000,
      },
    ],
    adjuntos: [
      {
        id: 'file-2',
        filename: 'FB0004-00004561.jpg',
        url: '/uploads/FB0004-00004561.jpg',
        mimeType: 'image/jpeg',
        size: 145880,
      },
    ],
    observaciones: 'Pago contado contra entrega.',
    estado: 'Registrada',
    createdAt: '2024-08-21T12:10:00.000Z',
    updatedAt: '2024-08-22T10:15:00.000Z',
  },
  {
    id: 'comp-3',
    supplierId: 'prov-3',
    tipo: 'Factura C',
    puntoVenta: '0002',
    numero: '00000087',
    fecha: '2024-07-05',
    cae: null,
    caeVto: null,
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: 56000,
      iva21: 0,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: 56000,
    },
    items: [
      {
        id: 'comp-3-item-1',
        codigo: 'ASESORIA',
        descripcion: 'Servicios contables mensual',
        cantidad: 1,
        precio: 56000,
        alicuotaIva: 0,
        subtotal: 56000,
      },
    ],
    adjuntos: [],
    observaciones: 'Factura monotributo sin IVA.',
    estado: 'Pagada',
    createdAt: '2024-07-05T09:00:00.000Z',
    updatedAt: '2024-07-15T16:42:00.000Z',
  },
  {
    id: 'comp-4',
    supplierId: 'prov-4',
    tipo: 'Factura A',
    puntoVenta: '0006',
    numero: '00009872',
    fecha: '2024-10-03',
    cae: '66234588771234',
    caeVto: '2024-10-13',
    moneda: 'ARS',
    condicionCompra: 'Contado',
    importes: {
      neto: 125000,
      iva21: 26250,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 3500,
      otros: 0,
      total: 154750,
    },
    items: [
      {
        id: 'comp-4-item-1',
        codigo: 'INS-FRIO',
        descripcion: 'Insumos refrigeración',
        cantidad: 10,
        precio: 12500,
        alicuotaIva: 21,
        subtotal: 125000,
      },
    ],
    adjuntos: [],
    observaciones: 'Proveedor actualmente inactivo.',
    estado: 'Registrada',
    createdAt: '2024-10-03T18:55:00.000Z',
    updatedAt: '2024-10-04T09:15:00.000Z',
  },
  {
    id: 'comp-5',
    supplierId: 'prov-5',
    tipo: 'Nota de Crédito',
    puntoVenta: '0001',
    numero: '00000032',
    fecha: '2024-09-15',
    cae: '56300234889912',
    caeVto: '2024-09-25',
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: -22000,
      iva21: -4620,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: -26620,
    },
    items: [
      {
        id: 'comp-5-item-1',
        codigo: 'NC-SOP',
        descripcion: 'Nota de crédito soporte remoto',
        cantidad: 1,
        precio: -22000,
        alicuotaIva: 21,
        subtotal: -22000,
      },
    ],
    adjuntos: [],
    observaciones: 'Bonificación por indisponibilidad.',
    estado: 'Registrada',
    createdAt: '2024-09-15T14:22:00.000Z',
    updatedAt: '2024-09-15T14:22:00.000Z',
  },
  {
    id: 'comp-6',
    supplierId: 'prov-1',
    tipo: 'Factura M',
    puntoVenta: '0001',
    numero: '00001237',
    fecha: '2024-10-18',
    cae: '78231000998877',
    caeVto: '2024-10-28',
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: 650000,
      iva21: 136500,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 25000,
      percepIibb: 0,
      otros: 7500,
      total: 819000,
    },
    items: [
      {
        id: 'comp-6-item-1',
        codigo: 'SERV-CAM',
        descripcion: 'Servicio transporte cámara térmica',
        cantidad: 1,
        precio: 650000,
        alicuotaIva: 21,
        subtotal: 650000,
      },
    ],
    adjuntos: [],
    observaciones: 'Alta carga térmica temporada.',
    estado: 'Registrada',
    createdAt: '2024-10-18T18:10:00.000Z',
    updatedAt: '2024-10-18T18:10:00.000Z',
  },
  {
    id: 'comp-7',
    supplierId: 'prov-2',
    tipo: 'Factura A',
    puntoVenta: '0004',
    numero: '00004890',
    fecha: '2024-06-12',
    cae: '46231011993344',
    caeVto: '2024-06-22',
    moneda: 'ARS',
    condicionCompra: 'Contado',
    importes: {
      neto: 54000,
      iva21: 11340,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: 65340,
    },
    items: [
      {
        id: 'comp-7-item-1',
        codigo: 'SERV-MANT',
        descripcion: 'Mantenimiento correctivo',
        cantidad: 1,
        precio: 54000,
        alicuotaIva: 21,
        subtotal: 54000,
      },
    ],
    adjuntos: [],
    observaciones: 'Reparación ascensor interno.',
    estado: 'Pagada',
    createdAt: '2024-06-12T11:05:00.000Z',
    updatedAt: '2024-06-20T10:05:00.000Z',
  },
  {
    id: 'comp-8',
    supplierId: 'prov-3',
    tipo: 'Factura B',
    puntoVenta: '0002',
    numero: '00000101',
    fecha: '2024-05-29',
    cae: '33441222334455',
    caeVto: '2024-06-08',
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: 62000,
      iva21: 13020,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: 75020,
    },
    items: [
      {
        id: 'comp-8-item-1',
        codigo: 'CONSULTA',
        descripcion: 'Consultoría impositiva',
        cantidad: 1,
        precio: 62000,
        alicuotaIva: 21,
        subtotal: 62000,
      },
    ],
    adjuntos: [],
    observaciones: 'Incluye revisión anual AFIP.',
    estado: 'Registrada',
    createdAt: '2024-05-29T08:40:00.000Z',
    updatedAt: '2024-05-29T08:40:00.000Z',
  },
  {
    id: 'comp-9',
    supplierId: 'prov-5',
    tipo: 'Factura A',
    puntoVenta: '0001',
    numero: '00000125',
    fecha: '2024-04-17',
    cae: '55662044997711',
    caeVto: '2024-04-27',
    moneda: 'ARS',
    condicionCompra: 'Cuenta Corriente',
    importes: {
      neto: 132000,
      iva21: 27720,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 1800,
      total: 161520,
    },
    items: [
      {
        id: 'comp-9-item-1',
        codigo: 'SOP-IT',
        descripcion: 'Servicio soporte on-site',
        cantidad: 8,
        precio: 16500,
        alicuotaIva: 21,
        subtotal: 132000,
      },
    ],
    adjuntos: [],
    observaciones: 'Incluye viáticos interior.',
    estado: 'Registrada',
    createdAt: '2024-04-17T12:12:00.000Z',
    updatedAt: '2024-04-17T12:12:00.000Z',
  },
  {
    id: 'comp-10',
    supplierId: 'prov-4',
    tipo: 'Factura B',
    puntoVenta: '0006',
    numero: '00009770',
    fecha: '2024-03-03',
    cae: '44221000889955',
    caeVto: '2024-03-13',
    moneda: 'ARS',
    condicionCompra: 'Contado',
    importes: {
      neto: 78000,
      iva21: 16380,
      iva105: 0,
      iva27: 0,
      exento: 0,
      noGravado: 0,
      percepIva: 0,
      percepIibb: 0,
      otros: 0,
      total: 94380,
    },
    items: [
      {
        id: 'comp-10-item-1',
        codigo: 'EQUIP-FRIO',
        descripcion: 'Repuestos equipos frío',
        cantidad: 6,
        precio: 13000,
        alicuotaIva: 21,
        subtotal: 78000,
      },
    ],
    adjuntos: [],
    observaciones: 'Facturado en sucursal Bariloche.',
    estado: 'Registrada',
    createdAt: '2024-03-03T09:34:00.000Z',
    updatedAt: '2024-03-03T09:34:00.000Z',
  },
];

export function createPurchaseSeeds() {
  return purchasesSeed.map(item => JSON.parse(JSON.stringify(item)));
}

export function getSupplierById(id) {
  return supplierRef.find(supplier => supplier.id === id) || null;
}

